import style from "./LibraryHeader.module.css";

export const LibraryHeader = ({username}) => {
    return (
        <div className={style.container}>
            <span className={style.header}>{username}のライブラリ</span>
        </div>
    );
};